module.exports = __webpack_public_path__ + "img/message.3f99f47c.svg";